import WildAppResource from "./WildAppResource";
import LuHslpUpsellPurchasedByTypeAppResource from "./LuHslpUpsellPurchasedByTypeAppResource";
import LuHslpUpsellPaymentFromAppResource from "./LuHslpUpsellPaymentFromAppResource";
import LuHslpUpsellPaymentTermAppResource from "./LuHslpUpsellPaymentTermAppResource";
import LuHslpCancellationReasonAppResource from "./LuHslpCancellationReasonAppResource";
import OrderAppResource from './OrderAppResource';

class HomeSaleLegalProtectionAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'home-sale-legal-protection';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'homes/sales/legals/protections';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'upsellPurchasedById',
            'upsellPaymentTermId',
            'upsellPrice',
            'upsellPurchasedAt',
            'upsellCancelledAt',
            'cancelledAt',
            'cancellationReasonId',
            'legalProtectionAmount',
            'yearsLegalProtection',
            'tier',
            'orderUuid',
            'paymentFromId'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            upsellPurchasedBy: LuHslpUpsellPurchasedByTypeAppResource,
            upsellPaymentTerm: LuHslpUpsellPaymentTermAppResource,
            paymentFrom: LuHslpUpsellPaymentFromAppResource,
            cancellationReason: LuHslpCancellationReasonAppResource,
            order: OrderAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            upsellPurchasedBy: 'upsell_purchased_by_id',
            upsellPaymentTerm: 'upsell_payment_term_id',
            paymentFrom: 'payment_from_id',
            cancellationReason: 'cancellation_reason_id',
            order: 'order_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            orderUuid: {
                type: 'string',
            },
        };
    }

}

export default HomeSaleLegalProtectionAppResource;
